/* eslint-disable max-lines */
import { SelectionGroupOption } from 'common/components';
import { ImageStructure, DesignStudioGalleryStructure } from './design-studio-gallery-types';
import { createGalleryList } from './design-studio-utils';

export const IMAGE_PER_PAGE = 10;

export enum DesignStudioRoomTabName {
  All = '1',
  LivingRoom = '2',
  Bedroom = '3',
  Kitchen = '4',
  Hall = '5',
  ChildrenRoom = '6',
  Bathroom = '7',
}

export const DESIGN_STUDIO_ROOM_LIST: SelectionGroupOption[] = [
  {
    text: 'Все',
    value: DesignStudioRoomTabName.All,
  },
  {
    text: 'Гостиная',
    value: DesignStudioRoomTabName.LivingRoom,
  },
  {
    text: 'Спальня',
    value: DesignStudioRoomTabName.Bedroom,
  },
  {
    text: 'Кухня',
    value: DesignStudioRoomTabName.Kitchen,
  },
  {
    text: 'Прихожая',
    value: DesignStudioRoomTabName.Hall,
  },
  {
    text: 'Детская',
    value: DesignStudioRoomTabName.ChildrenRoom,
  },
  {
    text: 'Санузел',
    value: DesignStudioRoomTabName.Bathroom,
  },
];

const ALL_ROOM_IMAGE_LIST: ImageStructure[] = [
  { imageName: '1.gif/1.gif', alt: 'Дизайн проект спальни в природном стиле' },
  { imageName: '2.jpg/2.jpg', alt: 'Современный интерьер детской в квартире' },
  { imageName: '3.jpg/3.jpg', alt: 'Дизайн кухни гостиной для большой семьи' },
  { imageName: '4.jpg/4.jpg', alt: 'Дизайн интерьера спальни с деревом в интерьере' },
  { imageName: '5.jpg/5.jpg', alt: 'Дизайн интерьера небольшой гостиной квартиры' },
  { imageName: '6.jpg/6.jpg', alt: 'Дизайн проект прихожей с мраморным полом' },
  { imageName: '7.gif/7.gif', alt: 'Современная гостиная дома со стеной под кирпич' },
  { imageName: '8.jpg/8.jpg', alt: 'Дизайн совмещённой кухни с гостиной в бежевых тонах' },
  { imageName: '9.jpg/9.jpg', alt: 'Дизайн интерьера современной кухни в доме' },
  { imageName: '10.jpg/10.jpg', alt: 'Дизайн проект функциональной ванной в квартире' },
  { imageName: '11.jpg/11.jpg', alt: 'Дизайн уютной спальни с деревянной отделкой' },
  { imageName: '12.jpg/12.jpg', alt: 'Современная детская с фото-печатью на всю стену' },
  { imageName: '13.jpg/13.jpg', alt: 'Дизайн кухни гостиной с балками на потолке' },
  { imageName: '14.jpg/14.jpg', alt: 'Дизайн ярко освещённой кухни' },
  { imageName: '15.gif/15.gif', alt: 'Белая мебель в интерьере прихожей' },
  { imageName: '16.jpg/16.jpg', alt: 'Дизайн гостиной с высокими потолками' },
  { imageName: '17.jpg/17.jpg', alt: 'Дизайн спальни с зеркальным шкафом' },
  { imageName: '18.jpg/18.jpg', alt: 'Дизайн интерьера детской для двоих' },
  { imageName: '19.jpg/19.jpg', alt: 'Дизайн кухни с деревянными вставками' },
  { imageName: '20.jpg/20.jpg', alt: 'Интерьер белой прихожей с диваном' },
  { imageName: '21.jpg/21.jpg', alt: 'Интерьер ванной с разноцветной плиткой' },
  { imageName: '22.jpg/22.jpg', alt: 'Дизайн интерьера детской игровой комнаты' },
  { imageName: '23.gif/23.gif', alt: 'Светлая кухня с яркой плиткой' },
  { imageName: '24.jpg/24.jpg', alt: 'Интерьер ванной с имитацией под дерево' },
  { imageName: '25.jpg/25.jpg', alt: 'Дизайн интерьера современной гостиной' },
  { imageName: '26.jpg/26.jpg', alt: 'Дизайн интерьера спальни кабинета' },
  { imageName: '27.jpg/27.jpg', alt: 'Минимализм в дизайне современной кухни' },
  { imageName: '28.jpg/28.jpg', alt: 'Интерьер прихожей с белым шкафом' },
  { imageName: '29.jpg/29.jpg', alt: 'Дизайн детской с настенным освещением' },
  { imageName: '30.gif/30.gif', alt: 'Дизайнт интерьера светлой детской комнаты' },
  { imageName: '31.jpg/31.jpg', alt: 'Современный дизайн кухни в стиле лофт' },
  { imageName: '32.jpg/32.jpg', alt: 'Сочетание мрамора и дерева в интерьере ванной' },
  { imageName: '33.jpg/33.jpg', alt: 'Дизайн интерьера прихожей с зеркальным шкафом' },
  { imageName: '34.jpg/34.jpg', alt: 'Интерьер спальни с настенной мозаикой' },
  { imageName: '35.jpg/35.jpg', alt: 'Дизайн гостиной с камином' },
  { imageName: '36.gif/36.gif', alt: 'Интерьер спальни в серых тонах' },
  { imageName: '37.jpg/37.jpg', alt: 'Дизайн кухни с барной стойкой-столом' },
  { imageName: '38.jpg/38.jpg', alt: 'Дизайн интерьера небольшой кухни гостиной' },
  { imageName: '39.jpg/39.jpg', alt: 'Ванная с деревянными акцентами в интерьере' },
  { imageName: '40.jpg/40.jpg', alt: 'Дизайн интерьера детской на мансарде' },
  { imageName: '41.jpg/41.jpg', alt: 'Дерево в дизайне прихожей квартиры' },
  { imageName: '42.jpg/42.jpg', alt: 'Телевизор в интерьере спальни' },
  { imageName: '43.jpg/43.jpg', alt: 'Дизайн ванной с зеркалом с подсветкой' },
  { imageName: '44.jpg/44.jpg', alt: 'Дизайн детской с угловой системой хранения' },
  { imageName: '45.gif/45.gif', alt: 'Дизайн интерьера прихожей в тёмно-сером цвете' },
  { imageName: '46.jpg/46.jpg', alt: 'Золотой цвет в дизайне интерьера гостиной' },
  { imageName: '47.jpg/47.jpg', alt: 'Современный дизайн ванной с чёрной раковиной' },
  { imageName: '48.jpg/48.jpg', alt: 'Синие акценты в дизайне современной кухни' },
  { imageName: '49.jpg/49.jpg', alt: 'Зеркала в интерьере прихожей' },
  { imageName: '50.jpg/50.jpg', alt: 'Дизайн интерьера спальни в спокойных оттенках' },
  { imageName: '51.jpg/51.jpg', alt: 'Дерево в интерьере современной ванной комнаты' },
  { imageName: '52.gif/52.gif', alt: 'Цветочный дизайн интерьера детской' },
  { imageName: '53.jpg/53.jpg', alt: 'Белый интерьер гостиной' },
  { imageName: '54.jpg/54.jpg', alt: 'Дизайн интерьера длинной узкой прихожей' },
  { imageName: '55.jpg/55.jpg', alt: 'Дизайн интерьера кабинета в детской' },
  { imageName: '56.jpg/56.jpg', alt: 'Светлая кухня с зеркальным столом' },
  { imageName: '57.jpg/57.jpg', alt: 'Мрамор в интерьере ванной' },
  { imageName: '58.jpg/58.jpg', alt: 'Обои с рисунком в дизайне серой спальни' },
  { imageName: '59.gif/59.gif', alt: 'Интерьер гостиной с синими акцентами' },
  { imageName: '60.jpg/60.jpg', alt: 'Дизайн интерьера небольшой кухни' },
  { imageName: '61.jpg/61.jpg', alt: 'Современный дизайн детской с телевизором и кабинетом' },
  { imageName: '62.jpg/62.jpg', alt: 'Дизайн интерьера ванной с зеркалом в виде сот' },
  { imageName: '63.jpg/63.jpg', alt: 'Интерьер прихожей с большим шкафом' },
  { imageName: '64.jpg/64.jpg', alt: 'Дизайн современной кухни гостиной на мансарде' },
  { imageName: '65.jpg/65.jpg', alt: 'Дизайн интерьера небольшой угловой кухни' },
  { imageName: '66.gif/66.gif', alt: 'Интерьер спальни в тропическом стиле' },
  { imageName: '67.jpg/67.jpg', alt: 'Дизайн интерьера небольшой прихожей' },
  { imageName: '68.jpg/68.jpg', alt: 'Дизайн детской с рабочим местом' },
  { imageName: '69.jpg/69.jpg', alt: 'Интерьер ванной с деревянной вставкой' },
  { imageName: '70.jpg/70.jpg', alt: 'Дизайн детской для двоих с рабочим местом' },
  { imageName: '71.jpg/71.jpg', alt: 'Тёплые тона в интерьере спальни' },
  { imageName: '72.jpg/72.jpg', alt: 'Дизайн интерьера просторной кухни' },
  { imageName: '73.jpg/73.jpg', alt: 'Дизайн рабочего места в интерьере детской' },
  { imageName: '74.jpg/74.jpg', alt: 'Дизайн интерьера белой кухни с барной стойкой' },
  { imageName: '75.jpg/75.jpg', alt: 'Интерьер прихожей в коричневых тонах' },
  { imageName: '76.jpg/76.jpg', alt: 'Дизайн интерьера современной спальни' },
  { imageName: '77.jpg/77.jpg', alt: 'Оранжевые акценты в интерьере ванной' },
  { imageName: '78.jpg/78.jpg', alt: 'Дизайн белой ванной комнаты с душевой' },
  { imageName: '79.jpg/79.jpg', alt: 'Натуральные материалы в интерьере гостиной' },
  { imageName: '80.jpg/80.jpg', alt: 'Дизайн интерьера узкой прихожей' },
  { imageName: '81.jpg/81.jpg', alt: 'Светлый дизайн детской с рабочим местом' },
  { imageName: '82.jpg/82.jpg', alt: 'Дизайн интерьера спальни в природных оттенках' },
  { imageName: '83.jpg/83.jpg', alt: 'Роскошь в дизайне бежевой гостиной' },
  { imageName: '84.jpg/84.jpg', alt: 'Интерьер светлой прихожей с ковром' },
  { imageName: '85.jpg/85.jpg', alt: 'Дизайн интерьера большой кухни' },
  { imageName: '86.jpg/86.jpg', alt: 'Интерьер маленькой прихожей' },
  { imageName: '87.jpg/87.jpg', alt: 'Дизайн кухни гостиной с мрамором в интерьере' },
  { imageName: '88.jpg/88.jpg', alt: 'Дизайн интерьера небольшой ванной' },
  { imageName: '89.jpg/89.jpg', alt: 'Рабочее место у окна в дизайне детской' },
  { imageName: '90.jpg/90.jpg', alt: 'Дизайн интерьера просторной ванной' },
];

const LIVING_ROOM_IMAGE_LIST: ImageStructure[] = [
  { imageName: '13.jpg/13.jpg', alt: 'Дизайн кухни гостиной с балками на потолке' },
  { imageName: '7.gif/7.gif', alt: 'Современная гостиная со стеной под кирпич' },
  { imageName: '5.jpg/5.jpg', alt: 'Интерьер небольшой гостиной' },
  { imageName: '8.jpg/8.jpg', alt: 'Дизайн совмещённой кухни с гостиной в бежевых тонах' },
  { imageName: '16.jpg/16.jpg', alt: 'Дизайн гостиной с высокими потолками' },
  { imageName: '79.jpg/79.jpg', alt: 'Натуральные материалы в интерьере гостиной' },
  { imageName: '46.jpg/46.jpg', alt: 'Золотой цвет в дизайне интерьера гостиной' },
  { imageName: '38.jpg/38.jpg', alt: 'Дизайн интерьера небольшой кухни гостиной' },
  { imageName: '53.jpg/53.jpg', alt: 'Белый интерьер гостиной' },
  { imageName: '59.gif/59.gif', alt: 'Интерьер гостиной с синими акцентами' },
  { imageName: '35.jpg/35.jpg', alt: 'Дизайн гостиной с камином' },
  { imageName: '87.jpg/87.jpg', alt: 'Дизайн кухни гостиной с мрамором в интерьере' },
  { imageName: '25.jpg/25.jpg', alt: 'Дизайн интерьера современной гостиной' },
  { imageName: '64.jpg/64.jpg', alt: 'Дизайн современной кухни гостиной на мансарде' },
  { imageName: '83.jpg/83.jpg', alt: 'Роскошь в дизайне бежевой гостиной' },
];

const BEDROOM_IMAGE_LIST: ImageStructure[] = [
  { imageName: '11.jpg/11.jpg', alt: 'Дизайн уютной спальни с деревянной отделкой' },
  { imageName: '29.jpg/29.jpg', alt: 'Дизайн детской с настенным освещением' },
  { imageName: '17.jpg/17.jpg', alt: 'Дизайн спальни с зеркальным шкафом' },
  { imageName: '4.jpg/4.jpg', alt: 'Дизайн спальни с деревом в интерьере' },
  { imageName: '1.gif/1.gif', alt: 'Дизайн спальни в природном стиле' },
  { imageName: '42.jpg/42.jpg', alt: 'Телевизор в интерьере спальни' },
  { imageName: '50.jpg/50.jpg', alt: 'Дизайн интерьера спальни в спокойных оттенках' },
  { imageName: '34.jpg/34.jpg', alt: 'Интерьер спальни с настенной мозаикой' },
  { imageName: '76.jpg/76.jpg', alt: 'Дизайн интерьера современной спальни' },
  { imageName: '66.gif/66.gif', alt: 'Интерьер спальни в тропическом стиле' },
  { imageName: '71.jpg/71.jpg', alt: 'Тёплые тона в интерьере спальни' },
  { imageName: '82.jpg/82.jpg', alt: 'Дизайн интерьера спальни в природных оттенках' },
  { imageName: '26.jpg/26.jpg', alt: 'Дизайн интерьера спальни кабинета' },
  { imageName: '58.jpg/58.jpg', alt: 'Обои с рисунком в дизайне серой спальни' },
  { imageName: '36.gif/36.gif', alt: 'Интерьер спальни в серых тонах' },
];

const KITCHEN_IMAGE_LIST: ImageStructure[] = [
  { imageName: '31.jpg/31.jpg', alt: 'Современный дизайн кухни в стиле лофт' },
  { imageName: '23.gif/23.gif', alt: 'Светлая кухня с яркой плиткой' },
  { imageName: '19.jpg/19.jpg', alt: 'Дизайн кухни с деревянными вставками' },
  { imageName: '48.jpg/48.jpg', alt: 'Синие акценты в дизайне современной кухни' },
  { imageName: '37.jpg/37.jpg', alt: 'Дизайн кухни с барной стойкой-столом' },
  { imageName: '3.jpg/3.jpg', alt: 'Дизайн кухни гостиной для большой семьи' },
  { imageName: '9.jpg/9.jpg', alt: 'Интерьер современной кухни с барной стойкой' },
  { imageName: '14.jpg/14.jpg', alt: 'Дизайн ярко освещённой кухни' },
  { imageName: '56.jpg/56.jpg', alt: 'Светлая кухня с зеркальным столом' },
  { imageName: '60.jpg/60.jpg', alt: 'Дизайн интерьера небольшой кухни' },
  { imageName: '27.jpg/27.jpg', alt: 'Минимализм в дизайне современной кухни' },
  { imageName: '65.jpg/65.jpg', alt: 'Дизайн интерьера небольшой угловой кухни' },
  { imageName: '72.jpg/72.jpg', alt: 'Дизайн интерьера просторной кухни' },
  { imageName: '74.jpg/74.jpg', alt: 'Дизайн интерьера белой кухни с барной стойкой' },
  { imageName: '85.jpg/85.jpg', alt: 'Дизайн интерьера большой кухни' },
];

const HALL_IMAGE_LIST: ImageStructure[] = [
  { imageName: '20.jpg/20.jpg', alt: 'Интерьер белой прихожей с диваном' },
  { imageName: '6.jpg/6.jpg', alt: 'Интерьер прихожей с мраморным полом' },
  { imageName: '15.gif/15.gif', alt: 'Белая мебель в интерьере прихожей' },
  { imageName: '28.jpg/28.jpg', alt: 'Интерьер прихожей с белым шкафом' },
  { imageName: '49.jpg/49.jpg', alt: 'Зеркала в интерьере прихожей' },
  { imageName: '41.jpg/41.jpg', alt: 'Дерево в дизайне прихожей квартиры' },
  { imageName: '33.jpg/33.jpg', alt: 'Дизайн интерьера прихожей с зеркальным шкафом' },
  { imageName: '54.jpg/54.jpg', alt: 'Дизайн интерьера длинной узкой прихожей' },
  { imageName: '63.jpg/63.jpg', alt: 'Интерьер прихожей с большим шкафом' },
  { imageName: '45.gif/45.gif', alt: 'Дизайн интерьера прихожей в тёмно-сером цвете' },
  { imageName: '67.jpg/67.jpg', alt: 'Дизайн интерьера небольшой прихожей' },
  { imageName: '75.jpg/75.jpg', alt: 'Интерьер прихожей в коричневых тонах' },
  { imageName: '80.jpg/80.jpg', alt: 'Дизайн интерьера узкой прихожей' },
  { imageName: '84.jpg/84.jpg', alt: 'Интерьер светлой прихожей с ковром' },
  { imageName: '86.jpg/86.jpg', alt: 'Интерьер маленькой прихожей' },
];

const CHILDREN_ROOM_IMAGE_LIST: ImageStructure[] = [
  { imageName: '12.jpg/12.jpg', alt: 'Современная детская с фото-печатью на всю стену' },
  { imageName: '30.gif/30.gif', alt: 'Дизайнт интерьера светлой детской комнаты' },
  { imageName: '22.jpg/22.jpg', alt: 'Дизайн интерьера детской игровой комнаты' },
  { imageName: '44.jpg/44.jpg', alt: 'Дизайн детской с угловой системой хранения' },
  { imageName: '40.jpg/40.jpg', alt: 'Дизайн интерьера детской на мансарде' },
  { imageName: '55.jpg/55.jpg', alt: 'Дизайн интерьера кабинета в детской' },
  { imageName: '61.jpg/61.jpg', alt: 'Современный дизайн детской с телевизором и кабинетом' },
  { imageName: '68.jpg/68.jpg', alt: 'Дизайн детской с рабочим местом' },
  { imageName: '52.gif/52.gif', alt: 'Цветочный дизайн интерьера детской' },
  { imageName: '73.jpg/73.jpg', alt: 'Дизайн рабочего места в интерьере детской' },
  { imageName: '70.jpg/70.jpg', alt: 'Дизайн детской для двоих с рабочим местом' },
  { imageName: '82.jpg/82.jpg', alt: 'Дизайн интерьера спальни в природных оттенках' },
  { imageName: '2.jpg/2.jpg', alt: 'Современный интерьер детской' },
  { imageName: '18.jpg/18.jpg', alt: 'Дизайн интерьера детской для двоих' },
  { imageName: '89.jpg/89.jpg', alt: 'Рабочее место у окна в дизайне детской' },
];

const BATHROOM_ROOM_IMAGE_LIST: ImageStructure[] = [
  { imageName: '21.jpg/21.jpg', alt: 'Интерьер ванной с разноцветной плиткой' },
  { imageName: '10.jpg/10.jpg', alt: 'Интерьер функциональной ванной' },
  { imageName: '32.jpg/32.jpg', alt: 'Сочетание мрамора и дерева в интерьере ванной' },
  { imageName: '24.jpg/24.jpg', alt: 'Интерьер ванной с имитацией под дерево' },
  { imageName: '51.jpg/51.jpg', alt: 'Дерево в интерьере современной ванной комнаты' },
  { imageName: '43.jpg/43.jpg', alt: 'Дизайн ванной с зеркалом с подсветкой' },
  { imageName: '39.jpg/39.jpg', alt: 'Ванная с деревянными акцентами в интерьере' },
  { imageName: '78.jpg/78.jpg', alt: 'Дизайн белой ванной комнаты с душевой' },
  { imageName: '47.jpg/47.jpg', alt: 'Современный дизайн ванной с чёрной раковиной' },
  { imageName: '62.jpg/62.jpg', alt: 'Дизайн интерьера ванной с зеркалом в виде сот' },
  { imageName: '57.jpg/57.jpg', alt: 'Мрамор в интерьере ванной' },
  { imageName: '77.jpg/77.jpg', alt: 'Оранжевые акценты в интерьере ванной' },
  { imageName: '69.jpg/69.jpg', alt: 'Интерьер ванной с деревянной вставкой' },
  { imageName: '88.jpg/88.jpg', alt: 'Дизайн интерьера небольшой ванной' },
  { imageName: '90.jpg/90.jpg', alt: 'Дизайн интерьера просторной ванной' },
];

export const DESIGN_STUDIO_GALLERY_MAP: Record<DesignStudioRoomTabName, DesignStudioGalleryStructure[]> = {
  [DesignStudioRoomTabName.All]: createGalleryList(ALL_ROOM_IMAGE_LIST),
  [DesignStudioRoomTabName.LivingRoom]: createGalleryList(LIVING_ROOM_IMAGE_LIST),
  [DesignStudioRoomTabName.Bedroom]: createGalleryList(BEDROOM_IMAGE_LIST),
  [DesignStudioRoomTabName.Kitchen]: createGalleryList(KITCHEN_IMAGE_LIST),
  [DesignStudioRoomTabName.Hall]: createGalleryList(HALL_IMAGE_LIST),
  [DesignStudioRoomTabName.ChildrenRoom]: createGalleryList(CHILDREN_ROOM_IMAGE_LIST),
  [DesignStudioRoomTabName.Bathroom]: createGalleryList(BATHROOM_ROOM_IMAGE_LIST),
};
